import {
  useQuery, UseQueryResult, useQueryClient, useMutation,
} from '@tanstack/react-query';
import { getDriverDetailsLocations, getDriverDetailsLocationsByIds } from '../../services/MapsService';
import { LocationDetailsResponse } from '../../types/Maps';

function useGetDriverLocations(
  fleetId: string,
  query: string,
  id: string,
  refetch = true,
): UseQueryResult<LocationDetailsResponse> {
  return useQuery(
    ['driverLocations', fleetId, id, query],
    async (): Promise<LocationDetailsResponse> => getDriverDetailsLocations(fleetId, id, query),
    {
      retry: 1,
      retryDelay: 3000,
      refetchInterval: refetch ? 5000 : false,
      keepPreviousData: true,
      enabled: !!id,
    },
  );
}

export function useGetDriverLocationsByIds(
  successCb: (args: LocationDetailsResponse[]) => void,
  failureCb: (error: string) => void,
): LocationDetailsResponse {
  const queryClient = useQueryClient();

  return useMutation(getDriverDetailsLocationsByIds, {
    onSuccess: (data) => {
      successCb(data);
      queryClient.invalidateQueries({ queryKey: ['driverLocationsByIds'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useGetDriverLocations;
